module.exports = __webpack_public_path__ + "img/38-1.15505316.jpg";